import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate } from '../../../utils/util';
import BackButton from '../../../components/UI/BackButton';
import { checkPermission } from '../../../services/auth';
import { PERMISSIONS } from '../../../utils/constants';

const Spawing = (props) => {

    const menu = () => {
        let menuItems = [];
 
        if (checkPermission(PERMISSIONS.Warehouse_Container.Spawning.Total)) {          
            menuItems = [...menuItems, { route: 'spawing/container', icon: 'mdi mdi-location-enter', text: translate('container:spawning:menu.total-spawing') }];
        }

        if (checkPermission(PERMISSIONS.Warehouse_Container.Spawning.List)) {          
            menuItems = [...menuItems, { route: 'spawing/list', icon: 'mdi mdi-location-enter', text: translate('container:spawning:menu.list-spawing') }];
        }

        return menuItems;
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('container:menu.spawning')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

export default withRouter(connect(mapStateToProps)(withRouter(withTranslation()(Spawing))));

